export default "__VITE_ASSET__XZw9S3iD__"